import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { newRequestUrl } from '@/constants/urls';
import { requestSources } from '@/requests/constants';
import StandardToolsMenu from '@/components/tools/StandardToolsMenu';
import DropdownItem from '@/components/DropdownItem';
import { newCohortFromDataset } from '@/cohorts/actions';
import datasetStatus from '@/datasets/status/helper';
import { datasetManagePermissions } from '@/datasets/sharing/constants';
import { collectionPermissions } from '../../sharing/constants';
import { removeCollectionDatasets } from '../actions';

const CollectionDatasetTools = ({
  category,
  code,
  dataset,
  url,
  accessRequestAllowed,
  accessRequestSupported,
  cohortAllowed,
  cohortSupported,
  allowManage,
  removeDataset,
  newCohortCode,
  newRequestCode,
  newCohort,
  upward,
  listItem = false,
}) => ((
  <StandardToolsMenu listItem={listItem} upward={upward} href={url} allowRead>
    {accessRequestAllowed && accessRequestSupported && (
    <DropdownItem
      icon="key"
      textId="actions.request.access"
      href={newRequestUrl(requestSources.DATASET, dataset.code, newRequestCode, '#')}
    />
    )}
    {cohortAllowed && cohortSupported && (
    <DropdownItem
      icon="filter"
      textId="actions.cohort"
      onClick={() => newCohort(newCohortCode, dataset.code, dataset.primary_dictionary)}
    />
    )}
    {allowManage && (
    <DropdownItem
      className="remove-dataset"
      icon="minus"
      textId="actions.remove"
      onClick={() => removeDataset(category, code, [dataset])}
    />
    )}
  </StandardToolsMenu>
));

const mapStateToProps = ({
  auth: { role },
  cohorts: { newCohortCode },
  collectionDatasets: { collectionDatasets },
  requests: { newRequestCode },
}, { category, code, dataset }) => {
  const item = findResult(collectionDatasets, category, code);
  const { permissions: datasetUserPermissions } = dataset;
  const collectionMemberPermissions = item ? item.permissions : {};

  return ({
    allowManage: role.permissions.collections.datasets
        || (datasetUserPermissions[datasetManagePermissions.COLLECTIONS]
            && collectionMemberPermissions[collectionPermissions.DATASETS]),
    newCohortCode,
    newRequestCode,
    ...datasetStatus(role, dataset, dataset.primary_dictionary),
  });
};

const mapDispatchToProps = {
  removeDataset: removeCollectionDatasets,
  newCohort: (code, datasetCode, dictionaryCode) => (
    newCohortFromDataset(code, 'open', datasetCode, [dictionaryCode])),
};

export default connect(mapStateToProps, mapDispatchToProps)(CollectionDatasetTools);
